exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-faqs[data-v-f3822a1c]{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;height:52vh;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
